import React from "react";

import { ensureString } from "@intelligems/ig-utils";
import { styled } from "@mui/material";

import { ButtonRoot } from "../components/ButtonRoot";
import { ExtraMessage } from "../components/ExtraMessage";
import { PriceSection } from "../components/PriceSection";
import { QuantityButtons } from "../components/QuantityButtons";
import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

export const QuantityButtonsWidget4 = () => {
  return (
    <Buttons
      renderButton={({ button, selected, index }) => (
        <Button
          key={index}
          button={button}
          selected={selected}
          renderContent={({
            button,
            unitDiscount,
            mode,
            discountedUnitPrice,
          }) => (
            <>
              <Price
                discountedUnitPrice={discountedUnitPrice}
                button={button}
              />
              <Message
                quantity={button.quantity}
                unitDiscount={unitDiscount}
                message={
                  button.extraMessage
                    ? ensureString(button.extraMessage)
                    : undefined
                }
                fullPriceMessage={button.fullPriceMessage}
                mode={mode}
              />
            </>
          )}
        />
      )}
    />
  );
};

const Buttons = styled(QuantityButtons)({
  gap: "10px",
});

const Button = styled(ButtonRoot)({
  height: 80,
  borderRadius: 0,
});

const Price = styled(PriceSection)({
  margin: 0,
});

const Message = styled(ExtraMessage)(() => {
  const { widget } = useQuantityButtonsContext();
  const { device } = widget;
  return {
    padding: "3px 0 3px 0",
    width: "100%",
    borderRadius: 0,
    minWidth: device === "desktop" ? 135 : 105,
  };
});
